import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import EmergencyInterventionDocument from "../../entity/b2csdu/EmergencyInterventionDocument";
import isNull from "../../mixin/isNull";
import axios from "axios";

const SERVICE = "service-b2csdu";
const ENTITY = "emergency_intervention_documents";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new EmergencyInterventionDocument(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        },
        getFile: async (id, fileId) => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `/service-b2csdu/application_v7/emergency_intervention_documents/${id}/${fileId}`);

                return response.data;
            } catch (e) {
                console.log(e);
                return null;
            }
        },
    }
}